/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_ChangesInputs */

const id_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const ms_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const da_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringer`)
};

const de_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen`)
};

const en_us2_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const es_es2_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const es_mx2_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fil_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pagbabago`)
};

const fr_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications`)
};

const it_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche`)
};

const hu_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változások`)
};

const nl_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen`)
};

const no_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringer`)
};

const pl_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiany`)
};

const pt_br2_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const pt_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações`)
};

const ro_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări`)
};

const fi_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutokset`)
};

const sv_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringar`)
};

const vi_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi`)
};

const tr_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklikler`)
};

const cs_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny`)
};

const bg_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промени`)
};

const ru_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменений`)
};

const uk_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміни`)
};

const ar_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات`)
};

const hi_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन`)
};

const th_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลง`)
};

const ja_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

const zh_cn2_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const zh_hant1_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const ko_components_stats_changes = /** @type {(inputs: Components_Stats_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Components_Stats_ChangesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_changes = /** @type {((inputs?: Components_Stats_ChangesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_ChangesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_changes(inputs)
	if (locale === "ms") return ms_components_stats_changes(inputs)
	if (locale === "da") return da_components_stats_changes(inputs)
	if (locale === "de") return de_components_stats_changes(inputs)
	if (locale === "en-US") return en_us2_components_stats_changes(inputs)
	if (locale === "es-ES") return es_es2_components_stats_changes(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_changes(inputs)
	if (locale === "fil") return fil_components_stats_changes(inputs)
	if (locale === "fr") return fr_components_stats_changes(inputs)
	if (locale === "it") return it_components_stats_changes(inputs)
	if (locale === "hu") return hu_components_stats_changes(inputs)
	if (locale === "nl") return nl_components_stats_changes(inputs)
	if (locale === "no") return no_components_stats_changes(inputs)
	if (locale === "pl") return pl_components_stats_changes(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_changes(inputs)
	if (locale === "pt") return pt_components_stats_changes(inputs)
	if (locale === "ro") return ro_components_stats_changes(inputs)
	if (locale === "fi") return fi_components_stats_changes(inputs)
	if (locale === "sv") return sv_components_stats_changes(inputs)
	if (locale === "vi") return vi_components_stats_changes(inputs)
	if (locale === "tr") return tr_components_stats_changes(inputs)
	if (locale === "cs") return cs_components_stats_changes(inputs)
	if (locale === "bg") return bg_components_stats_changes(inputs)
	if (locale === "ru") return ru_components_stats_changes(inputs)
	if (locale === "uk") return uk_components_stats_changes(inputs)
	if (locale === "ar") return ar_components_stats_changes(inputs)
	if (locale === "hi") return hi_components_stats_changes(inputs)
	if (locale === "th") return th_components_stats_changes(inputs)
	if (locale === "ja") return ja_components_stats_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_changes(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_changes(inputs)
	return ko_components_stats_changes(inputs)
});
export { components_stats_changes as "components.stats.changes" }